var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#1F4160",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "007-field-added-to-card",
    transform: "translate(-956.000000, -236.000000)",
    fill: "#1F4160",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(938.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-field",
    transform: "translate(18.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-plus",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13 5.41666667 7.58333333 5.41666667 7.58333333 0 5.41666667 0 5.41666667 5.41666667 0 5.41666667 0 7.58333333 5.41666667 7.58333333 5.41666667 13 7.58333333 13 7.58333333 7.58333333 13 7.58333333"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.5399839c372aa89ba90ed763909cb027.svg";
export { ForwardRef as ReactComponent };